import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next-btn",
  "use": "icon-next-btn-usage",
  "viewBox": "0 0 207 605",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 207 605\" id=\"icon-next-btn\">\n\t<title>next-btn</title>\n\t<style>\n\t\t#icon-next-btn tspan { white-space:pre }\n\t\t#icon-next-btn .shp0 { fill: #000000 } \n\t</style>\n\t<path id=\"icon-next-btn_next-btn\" class=\"shp0\" d=\"M0.7 0.5L206.3 302.5L0.7 604.5L0.7 0.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol